(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tika-brand-ambassadors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tika-ambassadors')) {
    customElements.define('tika-ambassadors', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-ambassador-track]');
        if (!this.track) return;
        this.cards = [...this.track.querySelectorAll('[data-ambassador-card]')];
        if (!this.cards.length) return;
        this.controls = this.querySelector('[data-ambassador-controls]');
        this.previous = this.querySelector('[data-ambassador-prev]');
        this.next = this.querySelector('[data-ambassador-next]');
        this.counter = this.querySelector('[data-ambassador-counter]');
        this.status = this.querySelector('[data-ambassador-status]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.updateFrame);
          this.updateFrame = requestAnimationFrame(() => this.update());
          clearTimeout(this.statusTimer);
          this.statusTimer = setTimeout(() => this.announce(), 180);
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.goTo(event.key === 'Home' ? 0 : this.positions.length - 1);
          }
        }, options);

        // Native touch / trackpad scrolling; add drag scrolling only for a mouse.
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.controls.hidden) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, moved: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const delta = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(delta) < 6) return;
          if (!this.drag.moved) {
            this.drag.moved = true;
            this.setAttribute('data-dragging', '');
            this.track.setPointerCapture(event.pointerId);
          }
          event.preventDefault();
          this.track.scrollLeft = this.drag.scroll - delta;
        }, options);
        const finishDrag = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const moved = this.drag.moved;
          this.drag = null;
          this.removeAttribute('data-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          if (moved) {
            this.suppressClick = true;
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
            this.update();
            this.goTo(this.index);
          }
        };
        this.track.addEventListener('pointerup', finishDrag, options);
        this.track.addEventListener('pointercancel', finishDrag, options);
        this.track.addEventListener('lostpointercapture', finishDrag, options);
        this.track.addEventListener('pointerleave', event => {
          if (this.drag && !this.drag.moved) finishDrag(event);
        }, options);
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }, { ...options, capture: true });
        this.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.scrollToOffset(this.cardOffset(card), true);
        }, options);
        this.observer = new ResizeObserver(() => this.measure());
        this.observer.observe(this.track);
        this.cards.forEach(card => this.observer.observe(card));
        this.setAttribute('data-enhanced', '');
        this.measure();
      }

      cardOffset(card) {
        const first = this.cards[0].getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        return this.rtl ? first.right - rect.right : rect.left - first.left;
      }

      measure() {
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        // Include the clamped final position so the last card is always reachable.
        this.positions = [0];
        this.cards.forEach(card => {
          const position = Math.min(this.maxScroll, Math.max(0, this.cardOffset(card)));
          if (position - this.positions[this.positions.length - 1] > 2) this.positions.push(position);
        });
        this.controls.hidden = this.maxScroll <= 2;
        this.update();
      }

      update() {
        const offset = Math.min(this.maxScroll, Math.max(0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft));
        this.index = this.positions.reduce((best, position, index) => Math.abs(position - offset) < Math.abs(this.positions[best] - offset) ? index : best, 0);
        this.previous.disabled = offset <= 2;
        this.next.disabled = offset >= this.maxScroll - 2;
        const view = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
          .filter(({ rect }) => Math.min(rect.right, view.right) - Math.max(rect.left, view.left) >= Math.min(rect.width, view.width) * .5);
        const first = (visible[0]?.index ?? 0) + 1;
        const last = (visible[visible.length - 1]?.index ?? 0) + 1;
        this.rangeText = `${first === last ? first : `${first}–${last}`} / ${this.cards.length}`;
        this.counter.textContent = this.rangeText;
      }

      announce() {
        if (this.status.textContent !== this.rangeText) this.status.textContent = this.rangeText;
      }

      move(direction) {
        this.goTo(Math.max(0, Math.min(this.positions.length - 1, this.index + direction)));
      }

      goTo(index) {
        this.scrollToOffset(this.positions[index]);
      }

      scrollToOffset(offset, immediate = false) {
        const position = Math.min(this.maxScroll, Math.max(0, offset));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.rtl ? -position : position, behavior: immediate || reduced ? 'instant' : 'smooth' });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.updateFrame);
        clearTimeout(this.statusTimer);
        clearTimeout(this.clickTimer);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.drag = null;
        this.suppressClick = false;
        this.removeAttribute('data-dragging');
        this.removeAttribute('data-enhanced');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
